import React, { useEffect, useState } from "react";
import Markdown from "react-markdown";
import { useParams } from "react-router-dom";
import { baseUrl } from "..";
import Frame from "../components/Frame";

const Page: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [content, setContent] = useState("");

  useEffect(() => {
    const getContent = async () => {
      const response = await fetch(baseUrl + "/api/pages/" + id);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data.data);
      setContent(data.data.content); // Adjust based on the structure of your API response
    };
    getContent();
  }, []);

  return (
    <Frame>
      <div className="flex justify-center">
        <div>
          <Markdown>{content}</Markdown>
        </div>
      </div>
    </Frame>
  );
};

export default Page;
